import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4b9799c8"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "source"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode(" 开始 ");

var _hoisted_3 = {
  class: "source"
};

var _hoisted_4 = /*#__PURE__*/_createTextVNode(" 查看记录 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_table = _resolveComponent("el-table");

  var _component_Pagination = _resolveComponent("Pagination");

  var _directive_loading = _resolveDirective("loading");

  return _openBlock(), _createElementBlock("div", null, [_ctx.tabsIndex == 0 ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
    key: 0,
    "show-header": false,
    data: _ctx.tableData,
    style: {
      "width": "100%"
    },
    "empty-text": "暂无数据",
    "element-loading-text": _ctx.tableloading,
    class: "el-table-index"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        label: "name",
        width: "400",
        class: "xxx"
      }, {
        default: _withCtx(function (scoped) {
          return [_createElementVNode("span", _hoisted_1, _toDisplayString(scoped.row.launchType == 2 ? _ctx.source : ""), 1), _createElementVNode("span", null, _toDisplayString(scoped.row.paperName), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        label: "time",
        width: "320"
      }, {
        default: _withCtx(function (scoped) {
          return [_createElementVNode("span", null, _toDisplayString(scoped.row.startTime) + " 至 " + _toDisplayString(scoped.row.finishTime), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        align: "right"
      }, {
        default: _withCtx(function (scoped) {
          return [_createVNode(_component_el_button, {
            type: "text",
            class: "btn_detail",
            onClick: function onClick($event) {
              return _ctx.start(scoped.row.paperId, scoped.row.recordId, scoped.row.paperId);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 2
          }, 1032, ["onClick"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data", "element-loading-text"])), [[_directive_loading, _ctx.loading]]) : _withDirectives((_openBlock(), _createBlock(_component_el_table, {
    key: 1,
    "show-header": false,
    data: _ctx.tableData,
    style: {
      "width": "100%"
    },
    "empty-text": "暂无数据",
    "element-loading-text": _ctx.tableloading,
    class: "el-table-index"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        label: "name",
        width: "300"
      }, {
        default: _withCtx(function (scoped) {
          return [_createElementVNode("span", _hoisted_3, _toDisplayString(scoped.row.launchType == 2 ? _ctx.source : ""), 1), _createElementVNode("span", null, _toDisplayString(scoped.row.paperName), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        label: "time",
        width: "200"
      }, {
        default: _withCtx(function (scoped) {
          return [_createTextVNode(_toDisplayString(scoped.row.handinTime), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        label: "operate",
        align: "right",
        width: "200"
      }, {
        default: _withCtx(function (scoped) {
          return [_createVNode(_component_el_button, {
            type: "text",
            class: "btn_detail",
            onClick: function onClick($event) {
              return _ctx.getDetail(scoped.row.recordId, scoped.row.state, scoped.row.paperId);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_4];
            }),
            _: 2
          }, 1032, ["onClick"])];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        label: "state",
        align: "right"
      }, {
        default: _withCtx(function (scoped) {
          return [_createElementVNode("span", {
            class: _normalizeClass(scoped.row.state == 1 ? 'stastart' : 'staend')
          }, _toDisplayString(scoped.row.state == 1 ? "已完成" : "已过期"), 3)];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data", "element-loading-text"])), [[_directive_loading, _ctx.loading]]), _createVNode(_component_Pagination, {
    pagesize: 10,
    "total-num": _ctx.totalNum,
    onChangPage: _ctx.changPage
  }, null, 8, ["total-num", "onChangPage"])]);
}